(ns teamoesterreich.admin-mode.data.rights
  (:require
    [clojure.string :as str]
    [clojure.walk]
    [goog.json :as json]
    [reagent.core :as r]
    [teamoesterreich.admin-mode.data.backend :as backend]
    [teamoesterreich.admin-mode.data.organisation :as d-organisation]
    [teamoesterreich.ajax :as ajax]
    [teamoesterreich.util.download :as h-download]
    [teamoesterreich.util.log :as log]
    [teamoesterreich.view-state :as v-state]))


(defonce CONTENT "content")
(defonce ADMIN_CONTENT "adminContent")
(defonce WARNING "warning")
(defonce USER_SEARCH "userSearch")
(defonce USER_EDIT "userEdit")
(defonce USER_DELETE "userDelete")
(defonce USER "user")
(defonce CLASSIC "classic")
(defonce CROWDTASKER "crowdTasker")
(defonce TRAINING "training")
(defonce CANYOU "canyou")
(defonce LEBENSRETTER "lebensretter")
(defonce LEBENSRETTER_ADMIN "lebensretterAdmin")
(defonce FIRST_RESPONDER "firstResponder")
(defonce FIRST_RESPONDER_POSTAL "firstResponderPostal")
(defonce LEBENSRETTER_LNA "lebensretterLna")
(defonce LEBENSRETTER_JKU "lebensretterJku")
(defonce NEIGHBOR "neighbor")
(defonce CLASSIC_ACTIVATE "classicActivate")
(defonce CROWDTASKER_ACTIVATE "crowdtaskerActivate")
(defonce TRAINING_ACTIVATE "trainingActivate")
(defonce CANYOU_ACTIVATE "canyouActivate")
(defonce LR_INCIDENT "lebensretterIncident")
(defonce ADMIN "admin")
(defonce PEER "bundPeer")
(defonce ADMIN_ORG "adminOrg")
(defonce COOL_PLACES "coolPlacesAdmin")



(defonce RIGHTS_LIST [

                      [USER_SEARCH {:name "Teilnehmersuche" :filter true :color "#edfff9" :group ""}]
                      [USER {:name "Teilnehmerbetreuung" :filter true :color "#f4ffff" :group ""}]
                      [USER_EDIT {:name "Benutzer bearbeiten" :filter true :color "#f4ffff" :group ""}]
                      [USER_DELETE {:name "Benutzer löschen" :filter true :color "#f4ffff" :group ""}]

                      [CLASSIC {:name "Einsätze erstellen/bearbeiten" :filter true :color "#ffe6e6" :group ""}]
                      [CLASSIC_ACTIVATE {:name "Einsätze freischalten" :filter false :color "#ffe6e6" :group ""}]

                      [CROWDTASKER {:name "Online-Einsätze erstellen/bearbeiten" :filter true :color "#fff2e6" :group ""}]
                      [CROWDTASKER_ACTIVATE {:name "Online-Einsätze freischalten" :filter false :color "#fff2e6" :group ""}]

                      [TRAINING {:name "Veranstaltungen erstellen/bearbeiten" :filter true :color "#fdffe6" :group ""}]
                      [TRAINING_ACTIVATE {:name "Veranstaltungen freischalten" :filter false :color "#fdffe6" :group ""}]

                      [CANYOU {:name "Kannst Du erstellen/bearbeiten" :filter true :color "#fdffe6" :group ""}]
                      [CANYOU_ACTIVATE {:name "Kannst Du freischalten" :filter false :color "#fdffe6" :group ""}]

                      [LEBENSRETTER {:name "Lebensretter verwalten" :filter true :color "#dbdcff" :group ""}]
                      [FIRST_RESPONDER {:name "First Responder verwalten" :filter false :color "#dbdcff" :group ""}]
                      [FIRST_RESPONDER_POSTAL {:name "FR PLZ-Alarm verwalten" :filter false :color "#dbdcff" :group ""}]
                      [LEBENSRETTER_LNA {:name "Lebensretter LNA verwalten" :filter false :color "#dbdcff" :group ""}]
                      [LEBENSRETTER_JKU {:name "LR JKU-Linz verwalten" :filter false :color "#dbdcff" :group ""}]
                      [PEER {:name "Lebensretter Peer" :filter false :color "#dbdcff" :group ""}]

                      [NEIGHBOR {:name "Nachbarschaftshilfe verwalten" :filter true :color "#adffa0" :group ""}]

                      [WARNING {:name "Warnungen verwalten" :filter true :color "#f4ffff" :group ""}]
                      [CONTENT {:name "Inhalte News/Content verwalten" :filter true :color "#fdffe6" :group ""}]
                      [ADMIN_CONTENT {:name "Vorlagen/Hilfe verwalten" :filter true :color "#fdffe6" :group ""}]

                      [ADMIN {:name "Benutzerrechte verwalten" :filter true :color "#ff7b7b" :group ""}]
                      [ADMIN_ORG {:name "Dienststellen verwalten" :filter true :color "#ff7b7b" :group ""}]
                      [COOL_PLACES {:name "Sommerfrische Admin" :filter true :color "#fffb7b"}]
                      ])

(defonce ONLY_SU "##")


(defn is-superuser? []
  (let [superUser? (get-in @v-state/app-state [:me :user-superUser])]
    superUser?))


(defn get-my-org-masks-for [section]
  (mapv :right-organisationMask
        (filter
          (fn [r] (and (:right-active r) (= (:right-section r) section)))
          (get-in @v-state/app-state [:me :user-right]))))

(defn get-right-name [right-key]
  (get-in (into {} RIGHTS_LIST) [right-key :name]))

(defn get-my-admin-rights [& [org-filters]]                 ;tod change for specific right mask
  (if (is-superuser?)
    RIGHTS_LIST
    (let [org-filters (or org-filters (get-my-org-masks-for ADMIN))
          org-filters (if (coll? org-filters) org-filters [org-filters])
          check-coll-fn (fn [r] (reduce (fn [c mask] (or c (re-find (re-pattern (str (or (:right-organisationMask r) "##"))) (str mask)))) false org-filters))
          res (reduce
                (fn [c r]
                  (if (and
                        (:right-active r)
                        (check-coll-fn r)
                        (get (into {} RIGHTS_LIST) (:right-section r)))
                    (let [r-obj (get (into {} RIGHTS_LIST) (:right-section r))] (assoc c (:right-section r) r-obj))
                    c
                    ))
                {}
                (get-in @v-state/app-state [:me :user-right]))]
      ;(print "############### filter Result " (clj->js res))
      res
      )))

(defn get-my-admin-right-list []
  (get-in @v-state/app-state [:me :user-right]))

;(in-ns 'teamoesterreich.admin-mode.data.rights)


(defn allow-admin-for [required-role & [orgId]]
  (let [superUser? (get-in @v-state/app-state [:me :user-superUser])
        rights (get-in @v-state/app-state [:me :user-right])
        right-sections (reduce (fn [c e] (if (true? (:right-active e)) (assoc c (:right-section e) true) c)) {} rights)
        right-filtered (reduce (fn [c e]
                                 ;(print "filter " e (re-find (re-pattern (str (or (:right-organisationMask e) "##"))) (str orgId)))
                                 (if (and (true? (:right-active e))
                                          (re-find (re-pattern (str (or (:right-organisationMask e) "##"))) (str orgId)))
                                   (assoc c (:right-section e) true) c)) {} rights)
        ]
    ;(log/debug "## rights allow-admin-for <<"  required-role ">> for " orgId " SU?" superUser? " sections:" (clj->js right-sections) "=>" (clj->js right-filtered))
    ;(log/debug "## rights all "  (clj->js rights))
    (cond
      superUser? true
      (and (nil? orgId) (get right-sections (str required-role))) true
      (and orgId (get right-filtered (str required-role))) true
      :else false
      )))


(defn get-rights-orgId-filter [required-role]
  (let [!superUser? (r/cursor v-state/app-state [:me :user-superUser])
        !rights (r/cursor v-state/app-state [:me :user-right])
        right-organisationMasks (reduce (fn [c e] (if (and (:right-active e) (= (:right-section e) required-role)) (conj c (:right-organisationMask e)) c)) [] @!rights)
        ]
    (cond
      @!superUser? [".*"]
      :else right-organisationMasks
      )))



(defn >edit-right [right-uuid obj done-fn]
  (ajax/auth-patch> (backend/get-auth) (str backend/BASE_URL "/rights/" right-uuid)
                    (ajax/serialize obj)
                    (fn [r-elm status]
                      (log/debug "set-right done" r-elm status)
                      (when (< status 300)
                        (done-fn
                          (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-elm))))
                          )))))

(defn >add-new [new done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/rights")
                   (ajax/serialize new)
                   (fn [r-elm status]
                     (log/debug ">add-new-right done" r-elm status)
                     (when (< status 300)
                       (done-fn
                         (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-elm))))
                         )))))




(defn <get-all [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/rights")
                  (fn [r-list status]
                    ;(log/debug "get-rights-all done" r-list status)
                    (when (= status 200)
                      (done-fn
                        (into {} (map (fn [e] [(get e "right-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                        )))))


(defn mask-to-reg
  "transforms a mask to a reg match able string"
  [org-mask]
  (-> org-mask
      (str/replace "." "X")
      (str/replace "*" "Y")
      ))




(defn get-my-admin-main []
  (let [_ (d-organisation/get-store-organisations)
        !organisations (r/cursor v-state/app-state [:organisations])
        main-list (reduce (fn [c [k v]] (assoc c (:organisation-orgFilter v) (:organisation-name v))) {} (d-organisation/get-main-multi-filter-list @!organisations (get-rights-orgId-filter ADMIN)))
        ]
    (merge {}
           [".*" "* Alle"]
           ["2." "* TempOrg"]
           main-list)
    ))

(defn get-my-admin-lv [filter_]
  (let [_ (d-organisation/get-store-organisations)
        !organisations (r/cursor v-state/app-state [:organisations])
        lv-list (reduce (fn [c [k v]] (assoc c (:organisation-orgFilter v) (:organisation-name v))) {} (d-organisation/get-org-multi-filter-list @!organisations (get-rights-orgId-filter ADMIN)))
        ]
    (merge {"" "Alle"}
           (filter (fn [[k v]]
                     (and
                       (try (if filter_ (re-matches (re-pattern filter_) (str k)) true)
                            (catch js/Error e "Invalid filter!"))))
                   lv-list)
           )))

(defn get-my-admin-dst [filter_]
  (let [_ (d-organisation/get-store-organisations)
        !organisations (r/cursor v-state/app-state [:organisations])
        dst-list (reduce (fn [c [k v]] (assoc c (or (:organisation-orgFilter v) (:organisation-key v)) (:organisation-name v))) {} (d-organisation/get-dest-multi-filter-list @!organisations (get-rights-orgId-filter ADMIN)))
        ]
    (merge {"" "Alle"}
           (filter (fn [[k v]]
                     (and
                       (try (if filter_ (re-matches (re-pattern filter_) (str k)) true)
                            (catch js/Error e "Invalid filter!"))))
                   dst-list)
           )))

(defn get-my-admin-dst-by-key [filter_]
  (let [_ (d-organisation/get-store-organisations)
        !organisations (r/cursor v-state/app-state [:organisations])
        dst-list (reduce (fn [c [k v]] (assoc c (:organisation-key v) (:organisation-name v))) {} (d-organisation/get-dest-multi-filter-list @!organisations (get-rights-orgId-filter ADMIN)))
        ]
    (merge {"" "Alle"}
           (filter (fn [[k v]]
                     (and
                       (try (if filter_ (re-matches (re-pattern filter_) (str k)) true)
                            (catch js/Error e "Invalid filter!"))))
                   dst-list)
           )))



(defn csv-list []
  (h-download/download-blob (backend/get-auth) (str backend/BASE_URL "/rights/csv") "RechteExport.csv"))

(defn agr-csv-list []
  (h-download/download-blob (backend/get-auth) (str backend/BASE_URL "/rights/agr-csv") "RechteExport.csv"))

